import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
// import { Projects } from "./components/Projects"; // You are using ProjectsNew, so this isn't strictly needed unless you plan to swap back
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Experience } from "./components/Experience";
import { Featured } from "./components/Featured";
import { ProjectsNew } from "./components/ProjectsNew";

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <Featured />
      <Experience />
      <ProjectsNew />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;